import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';

// Header Component
const Header = () => {
  return (
    <header>
      <nav> {/* Navigation content */} </nav>
    </header>
  );
};

// Footer Component
const Footer = () => {
  return (
    <footer> {/* Footer content */} </footer>
  );
};

// Page Form Component (for adding or editing pages)
const PageForm = ({ pageName, handleFormSubmit }) => {
  const [formData, setFormData] = useState({ pageName: pageName || '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleFormSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="stdform">
      <div className="panel-body">
        <div className="row">
          <div className="col-md-3">
            <div style={{ marginTop: '20px' }}>
              <label>Page Name</label>
              <input 
                type="text" 
                name="pageName" 
                value={formData.pageName} 
                onChange={handleChange} 
                className="form-control" 
                placeholder="Enter Page Name"
              />
            </div>
          </div>
          <div className="col-md-3 mt-4">
            <button type="submit" className="btn btn-primary mx-2">Submit</button>
            <button type="button" className="btn btn-danger" onClick={() => setFormData({ pageName: '' })} style={{ paddingLeft: '10px' }}>
              Clear All
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

// Page Table Component (for displaying the list of pages)
const PageTable = ({ pages, handleEdit }) => {
  return (
    <div className="table-responsive">
      <table className="table m-b-0">
        <thead>
          <tr>
            <th style={{ textAlign: 'center' }}>#</th>
            <th>Page Name</th>
            <th style={{ width: '1%' }} colSpan="2">Action</th>
          </tr>
        </thead>
        <tbody>
          {pages.map((page, index) => (
            <tr key={page.id}>
              <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{index + 1}</td>
              <td>{page.pageName}</td>
              <td>
                <button 
                  className="btn btn-warning btn-xs" 
                  style={{ float: 'left' }}
                  onClick={() => handleEdit(page.id)}
                >
                    <FontAwesomeIcon icon={faPencil} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Main Page Management Component
const MobilePageManagement = () => {
  const [pages, setPages] = useState([]);
  const [currentPageName, setCurrentPageName] = useState('');

  useEffect(() => {
    // Fetch pages data from the server on component mount
    axios.get('/pages')
      .then(response => setPages(response.data))
      .catch(error => console.error('Error fetching pages', error));
  }, []);

  const handleFormSubmit = (formData) => {
    // Handle the form submit to add or update page data
    if (currentPageName) {
      // Update page
      axios.put(`/pages/${currentPageName}`, formData)
        .then(response => {
          setPages(prevPages => prevPages.map(page => page.id === response.data.id ? response.data : page));
          setCurrentPageName('');
        });
    } else {
      // Add new page
      axios.post('/pages', formData)
        .then(response => setPages(prevPages => [...prevPages, response.data]));
    }
  };

  const handleEdit = (pageId) => {
    // Fetch page data for editing
    const pageToEdit = pages.find(page => page.id === pageId);
    setCurrentPageName(pageToEdit.id);
  };

  return (
    <div id="page-container" className="page-header-fixed page-sidebar-fixed fade in">
      <Header />
      <div id="content" className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <div className="panel-heading border-0">
            <span className="panel-title">Manage Pages</span>
          </div>
          <PageForm pageName={currentPageName} handleFormSubmit={handleFormSubmit} />
        </div>

        <div className="panel panel-default with-rounded-corner with-shadow">
          <div className="panel-heading border-0">
            <h4 className="panel-title pull-left">Manage Pages</h4>
          </div>
          {pages.length > 0 ? (
            <PageTable pages={pages} handleEdit={handleEdit} />
          ) : (
            <div>No Records</div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default MobilePageManagement;
